import { render, staticRenderFns } from "./jingbiao_tem.vue?vue&type=template&id=f36f45c8&"
import script from "./jingbiao_tem.vue?vue&type=script&lang=js&"
export * from "./jingbiao_tem.vue?vue&type=script&lang=js&"
import style0 from "./jingbiao_tem.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports